<template>
  <!-- Right Section for Product and Collection assignment -->
  <div class="right-section pr-0 ml-3 mt-3">
    <div class="assign-right-section d-flex flex-column p-2">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h1 class="typo-heading16 typo-medium text-light-high mr-half">{{ rightSectionTitle }}</h1>
          <i class="icon icon-help tip typo-icon-14 text-light-disabled clickable weight-800" v-popover:tooltip.bottom="tooltipRightSection"></i>
        </div>
        <div class="assign-right-section-actions d-flex align-items-center">
          <div class="reload-assign snack-loading" v-if="isLoadingAssign"><i class="icon icon-loading text-lightmode"></i></div>
          <a class="reload-assign" href="#" @click="fetchAllAssignItemsByType" :class="{ disabled: isLoadingAssign }" v-popover:tooltip.bottom="tooltipReloadStatus" v-else><i class="icon icon-restart"></i></a>
          <a href="#" class="close-assign" @click="emitClose"><i class="icon icon-cancel"></i></a>
        </div>
      </div>
      <GpInputSearch class="mt-2 mb-2 right-search flex-shrink-0" ref="GpRealInput" v-model="queryRightSection" @onChange="onChangeSearchRightSection" :placeholder="rightSectionPlaceholder" :indicating.sync="loadingRightSection" />
      <!-- Empty Right Section -->
      <template v-if="!(loadingRightSection || loadingInit) && allAssignItems.length == 0">
        <template v-if="isDefault">
          <div class="d-flex p-1 align-items-center border-dashed-gold">
            <i class="icon icon-warning tip mr-half mt-half align-self-baseline typo-icon-14"></i>
            <p class="typo-paragraph14 typo-regular-150 text-light-low">{{ defaultAssignedText }}</p>
          </div>
        </template>
        <div v-else class="full-width full-height mb-5 d-flex align-items-center justify-content-center px-5 text-center">
          <!-- <p class="typo-paragraph14 typo-regular-150 text-light-low" v-if="isDefault">{{ defaultAssignedText }}</p> -->
          <p class="typo-paragraph14 typo-regular-150 text-light-low" v-html="rightSectionDesc"></p>
          <!-- <p>{{ rightSectionDesc }}</p> -->
        </div>
      </template>
      <template v-else>
        <div class="position-relative full-width full-height" v-if="(loadingInit || loadingRightSection) && allAssignItems.length == 0">
          <GLoading size="small" />
        </div>
        <template v-else>
          <!-- <template v-if="isDefault()">
              <div class="full-width full-height mb-5 d-flex align-items-center justify-content-center px-5 text-center">
                <p>{{ defaultAssignedText }}</p>
              </div>
            </template> -->
          <template>
            <AssignList class="mr-n1" @mounted="initScrollAssignItems">
              <template v-slot:AssignItem>
                <template v-if="isDefault">
                  <div class="d-flex p-1 align-items-center border-dashed-gold">
                    <i class="icon icon-warning tip mr-half mt-half align-self-baseline typo-icon-14"></i>
                    <p class="typo-paragraph14 typo-regular-150 text-light-low">{{ defaultAssignedText }}</p>
                  </div>
                  <GpAccordion class="expandable">
                    <template #heading>
                      <div class="d-flex align-items-center noselect">
                        <p class="typo-paragraph14 weight-500">{{ viewCountAssigned }}</p>
                        <div class="actions ml-4">
                          <i class="icon icon-help tip mr-2 typo-icon-14" v-popover:tooltip.bottom="assignedTooltipText"></i>
                          <span class="arrow">
                            <i class="icon icon-arrow-right typo-icon-12"></i>
                          </span>
                        </div>
                      </div>
                    </template>
                    <template #items>
                      <AssignItem v-for="(item, index) in allAssignItems" :key="'assign' + index" :item="item" :type="type" @onClickUnAssign="onClickUnAssign" />
                    </template>
                  </GpAccordion>
                </template>
                <template v-else>
                  <AssignItem v-for="(item, index) in allAssignItems" :key="'assign' + index" :item="item" :type="type" @onClickUnAssign="onClickUnAssign" />
                </template>
              </template>
            </AssignList>
          </template>
        </template>
      </template>
      <button class="btn btn-default btn-block btn-secondary mt-auto" @click="openModalV2('addItems')" v-if="querriedTemplateByGroup && querriedTemplateByGroup.length">{{ rightSectionBtnText }}</button>
      <button class="btn btn-default btn-block btn-secondary mt-auto disabled" v-else disabled>{{ rightSectionBtnText }}</button>
    </div>

    <!-- Modal Add Items for Product Pages and Collection Pages -->
    <Modal :hideExit="true" @cancel="closeModalAddItems" v-if="modals.addItems.active" cClass="mw480 mnw480 h-734 gp-modal-add-items" mClass="p-0 pt-3" fClass="p-4 pt-2" preventBackdrop>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h1 class="typo-heading20 typo-medium text-light-high flex1">{{ modalAddItemsHeader }}</h1>
          <div class="d-flex gp-modal-add-items-head--actions">
            <template v-if="isLoading">
              <div class="snack-loading"><i class="icon icon-loading text-lightmode"></i></div>
            </template>
            <template v-else>
              <a href="#" @click="fetchAllItemsByType" :class="{ disabled: isLoading }" v-popover:tooltip.bottom="tooltipReloadStatus"><i class="icon icon-restart"></i></a>
            </template>
            <a href="#" @click="closeModalAddItems"><i class="icon icon-cancel"></i></a>
          </div>
        </div>
      </template>
      <template #default>
        <div class="d-flex justify-content-between pl-4 pr-4">
          <GpInputSearch autofocus ref="input" class="btn-block" :clear="true" v-model="querySearchAddItem" @onChange="onChangeSearchAddItem" :placeholder="rightSectionPlaceholder" :indicating="loadingAddItems" />
        </div>
        <PerfectScrollbar class="col-12 p-0 mt-3 mh464 overflow-x-hidden pr-4 pl-4 add-items-body">
          <div class="position-relative full-width full-height" v-if="loadingAddItems && (!querriedTemplateByGroup || !querriedTemplateByGroup.length)">
            <GLoading size="small" />
          </div>
          <template v-else>
            <template v-if="templateByGroup && templateByGroup.length">
              <template v-if="querriedTemplateByGroup && querriedTemplateByGroup.length">
                <GpAccordion :key="i + '_' + querySearchAddItem" v-for="(it, i) in querriedTemplateByGroup" :item="it" cClass="mh360 overflow-x-hidden mr-n1 pr-1" ref="accordion" :showFirst="forceShowItems" :class="{ 'mb-0': i == querriedTemplateByGroup.length - 1 }" :forceShow="querySearchAddItem != ''">
                  <template #heading="{toggle}">
                    <div class="d-flex align-items-center justify-content-between">
                      <p class="typo-heading16 typo-medium text-light-high add-item-title" @click="toggle" v-popover:tooltip.bottom="titlePage(it)">{{ titlePage(it) }}</p>
                      <div class="d-flex">
                        <div class="d-flex">
                          <!-- v-if="!it.published" -->
                          <p class="typo-paragraph12 typo-regular text-light-low mr-1">{{ itemCount(it) }}</p>
                          <i class="icon icon-arrow-up typo-paragraph12 typo-regular text-light-low"></i>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #items>
                    <AssignItem v-for="(item, index) in it.assigns" :key="'assign' + index" :item="item" :type="type" class="p-0 my-1" :hasCheckbox="true" @checkedUpdate="checkedUpdateItem" @onClickUnAssign="onClickUnAssign" :hasUnlink="false" />
                  </template>
                </GpAccordion>
              </template>
              <!-- search empty -->
              <template v-else>
                <div class="d-flex align-items-center justify-content-center p-6 text-center">
                  <p class="typo-paragraph14 typo-regular-150 text-light-low">{{ $t("page.typeSearchEmpty", { type: $tc(`page.${type.replace("pages", "Lower")}`) }) }}</p>
                </div>
              </template>
            </template>
            <!-- no more product/collection to assign  -->
            <template v-else>
              <div class="d-flex align-items-center justify-content-center p-6 text-center">
                <p class="typo-paragraph14 typo-regular-150 text-light-low">{{ $t("page.noMoreToAssign", { type: $tc(`page.${type.replace("pages", "Lower")}`) }) }}</p>
              </div>
            </template>
          </template>
        </PerfectScrollbar>
      </template>
      <template #footer>
        <div class="btn-group flex-row-reverse">
          <template>
            <ProcessButton class="btn btn-primary ml-1" @click="submitAddItems" :status.sync="btnStatus" type="submit">
              <template #loading>{{ $t("generals.loading") }}...</template>
              <template #success>{{ $t("generals.success") }}</template>
              <template #error>{{ $t("generals.error") }}</template>
              <template #default>{{ modalAddItemsBtnText }}</template>
            </ProcessButton>
          </template>

          <button class="btn btn btn-outline" @click="closeModalAddItems">{{ $t("generals.cancel") }}</button>
        </div>
      </template>
    </Modal>

    <!-- Modal Confirm Add Items -->
    <Modal :hideExit="true" @cancel="closeModalConfirmAddItems" v-if="modals.confirmAddItems.active" cClass="mw424">
      <template #header>
        <h1 class="typo-heading20 typo-medium text-light-high">{{ $t("generals.confirmation") }}</h1>
      </template>
      <template #default>
        <div class="row mb-2">
          <div class="col-7 d-flex flex-column justify-content-center">
            <p class="typo-custom-22b150 text-mono3">
              {{ $t("page.assignment.totalItems", { count: totalWillAddItems, type: $tc(`page.${type.replace("pages", "Lower")}`, totalWillAddItems) }) }}
            </p>
            <p class="typo-button14 typo-lh150 typo-semibold text-mono3">{{ $t("page.assignment.willBeAdd") }}</p>
          </div>
          <div class="col-5">
            <svg width="131" height="103" viewBox="0 0 131 103" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#gpca_filter0_d)">
                <rect x="88.416" y="56.4357" width="38.5644" height="38.5644" fill="#A5B9FF" />
                <path d="M112.377 72.169H103.017C102.77 72.179 102.536 72.2806 102.36 72.454C102.184 72.6274 102.079 72.8601 102.066 73.1067L100.652 83.2611C100.632 83.4009 100.641 83.5434 100.679 83.6795C100.717 83.8156 100.783 83.9423 100.872 84.0515C100.962 84.1607 101.074 84.25 101.2 84.3137C101.326 84.3774 101.464 84.4142 101.605 84.4216H113.79C113.931 84.4142 114.069 84.3774 114.195 84.3137C114.321 84.25 114.433 84.1607 114.522 84.0515C114.612 83.9423 114.678 83.8156 114.716 83.6795C114.754 83.5434 114.763 83.4009 114.743 83.2611L113.329 73.1067C113.316 72.8599 113.21 72.627 113.034 72.4536C112.858 72.2802 112.624 72.1787 112.377 72.169V72.169Z" stroke="#547AFF" stroke-width="1.625" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M111.179 72.169H104.216V70.4282C104.216 69.5049 104.583 68.6193 105.236 67.9664C105.889 67.3135 106.774 66.9467 107.698 66.9467C108.621 66.9467 109.507 67.3135 110.16 67.9664C110.813 68.6193 111.179 69.5049 111.179 70.4282V72.169Z" stroke="#547AFF" stroke-width="1.625" stroke-linecap="round" stroke-linejoin="round" />
              </g>
              <g filter="url(#gpca_filter1_d)">
                <rect x="46.4507" y="18.3842" width="52.588" height="52.588" fill="#A5B9FF" stroke="#0A3BE7" stroke-width="2" />
                <g>
                  <path d="M80.5237 60.0993C84.7444 60.0993 88.166 56.6778 88.166 52.457C88.166 48.2363 84.7444 44.8147 80.5237 44.8147C76.3029 44.8147 72.8813 48.2363 72.8813 52.457C72.8813 56.6778 76.3029 60.0993 80.5237 60.0993Z" stroke="#0A3BE7" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M80.5234 48.6359V56.2782" stroke="#0A3BE7" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M76.7021 52.457H84.3445" stroke="#0A3BE7" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M69.0597 56.2782H61.4174C60.9107 56.2782 60.4247 56.0769 60.0664 55.7186C59.7081 55.3603 59.5068 54.8743 59.5068 54.3676V33.3512C59.5068 32.8445 59.7081 32.3585 60.0664 32.0002C60.4247 31.6419 60.9107 31.4406 61.4174 31.4406H74.9558C75.4622 31.4407 75.9478 31.6418 76.3059 31.9998L79.9641 35.6579C80.322 36.0161 80.5231 36.5017 80.5232 37.008V40.9935" stroke="#0A3BE7" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M65.2389 37.65C65.3333 37.65 65.4257 37.678 65.5042 37.7305C65.5828 37.783 65.644 37.8576 65.6802 37.9449C65.7163 38.0322 65.7258 38.1282 65.7073 38.2209C65.6889 38.3135 65.6434 38.3986 65.5766 38.4654C65.5098 38.5322 65.4247 38.5777 65.3321 38.5961C65.2394 38.6146 65.1434 38.6051 65.0561 38.569C64.9688 38.5328 64.8942 38.4716 64.8417 38.393C64.7892 38.3145 64.7612 38.2221 64.7612 38.1277C64.7612 38.001 64.8116 37.8795 64.9011 37.7899C64.9907 37.7003 65.1122 37.65 65.2389 37.65Z" stroke="#0A3BE7" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M74.1917 43.0952L72.881 40.9936C72.795 40.8641 72.6786 40.7577 72.542 40.6834C72.4054 40.6092 72.2528 40.5695 72.0973 40.5677C71.9419 40.566 71.7884 40.6022 71.6501 40.6734C71.5119 40.7445 71.3931 40.8483 71.3042 40.9758L68.7567 44.6071L67.1875 43.35C67.0841 43.2671 66.9647 43.2067 66.8367 43.1725C66.7087 43.1383 66.575 43.131 66.444 43.1513C66.3131 43.1715 66.1878 43.2188 66.0762 43.29C65.9645 43.3613 65.8688 43.455 65.7953 43.5652L63.3281 48.6359H69.0599" stroke="#0A3BE7" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <circle cx="98.9471" cy="18.4759" r="4.36704" fill="#0A3BE7" />
                <circle cx="98.9471" cy="70.8804" r="4.36704" fill="#0A3BE7" />
                <circle cx="47.6341" cy="18.4759" r="4.36704" fill="#0A3BE7" />
                <circle cx="47.6341" cy="70.8804" r="4.36704" fill="#0A3BE7" />
              </g>
              <g filter="url(#gpca_filter2_d)">
                <rect x="19.7524" width="33.8614" height="33.8614" fill="#A5B9FF" />
                <g>
                  <path d="M46.5938 25.6442L44 23.0504C43.9511 23.0015 43.9149 22.9414 43.8946 22.8753C43.8743 22.8092 43.8705 22.7391 43.8835 22.6712C43.8966 22.6033 43.926 22.5397 43.9694 22.4858C44.0127 22.4319 44.0685 22.3894 44.1321 22.3621L44.6019 22.1607C44.7549 22.0948 44.885 21.9853 44.9761 21.8459C45.0671 21.7064 45.115 21.5432 45.1138 21.3766C45.1125 21.2101 45.0621 21.0476 44.969 20.9096C44.8758 20.7715 44.744 20.664 44.59 20.6005L39.2653 18.4071C39.1108 18.3435 38.9408 18.3271 38.7769 18.3599C38.613 18.3928 38.4625 18.4734 38.3444 18.5916C38.2262 18.7099 38.1458 18.8604 38.113 19.0243C38.0803 19.1882 38.0969 19.3582 38.1606 19.5127L40.3523 24.8374C40.4158 24.9916 40.5235 25.1236 40.6617 25.2168C40.8 25.31 40.9627 25.3603 41.1294 25.3614H41.1353C41.301 25.3614 41.463 25.3128 41.6013 25.2216C41.7395 25.1304 41.848 25.0007 41.9133 24.8484L42.1148 24.3794C42.1421 24.3159 42.1845 24.26 42.2384 24.2167C42.2923 24.1734 42.356 24.1439 42.4239 24.1309C42.4918 24.1179 42.5618 24.1217 42.6279 24.142C42.694 24.1623 42.7541 24.1985 42.803 24.2474L45.3968 26.8412C45.5564 26.9954 45.7703 27.0807 45.9922 27.0788C46.2142 27.0768 46.4265 26.9878 46.5835 26.8308C46.7404 26.6739 46.8295 26.4616 46.8314 26.2396C46.8333 26.0176 46.748 25.8038 46.5938 25.6442Z" fill="#547AFF" />
                  <path d="M36.4978 11.4748C36.47 11.438 36.434 11.4081 36.3928 11.3875C36.3515 11.367 36.306 11.3563 36.2599 11.3563C36.2138 11.3563 36.1683 11.367 36.127 11.3875C36.0857 11.4081 36.0498 11.438 36.022 11.4748L34.6117 13.3558C34.5734 13.4073 34.5527 13.4698 34.5527 13.534C34.5527 13.5982 34.5734 13.6606 34.6117 13.7122L36.022 15.5923C36.0498 15.6291 36.0857 15.659 36.127 15.6796C36.1683 15.7001 36.2138 15.7108 36.2599 15.7108C36.306 15.7108 36.3515 15.7001 36.3928 15.6796C36.434 15.659 36.47 15.6291 36.4978 15.5923L37.9081 13.7139C37.9464 13.6623 37.967 13.5999 37.967 13.5357C37.967 13.4715 37.9464 13.409 37.9081 13.3575L36.4978 11.4748Z" fill="#547AFF" />
                  <path d="M36.2612 18.6237H33.2983C33.1861 18.6237 33.0784 18.5791 32.999 18.4997C32.9197 18.4204 32.8751 18.3127 32.8751 18.2004V8.88855C32.8751 8.7763 32.9197 8.66864 32.999 8.58926C33.0784 8.50988 33.1861 8.46529 33.2983 8.46529H39.2241C39.3363 8.46529 39.444 8.50988 39.5234 8.58926C39.6027 8.66864 39.6473 8.7763 39.6473 8.88855V16.9416C39.6473 17.1662 39.7365 17.3815 39.8953 17.5402C40.054 17.699 40.2694 17.7882 40.4939 17.7882C40.7184 17.7882 40.9337 17.699 41.0925 17.5402C41.2512 17.3815 41.3404 17.1662 41.3404 16.9416V8.46529C41.3404 8.01626 41.162 7.58562 40.8445 7.26811C40.527 6.95059 40.0964 6.77222 39.6473 6.77222H32.8751C32.426 6.77222 31.9954 6.95059 31.6779 7.26811C31.3604 7.58562 31.182 8.01626 31.182 8.46529V9.69276L27.8297 10.4902C27.6133 10.5415 27.4091 10.6348 27.2288 10.765C27.0485 10.8952 26.8956 11.0597 26.7789 11.249C26.6621 11.4383 26.5838 11.6487 26.5484 11.8683C26.513 12.0879 26.5213 12.3123 26.5726 12.5287L28.9217 22.4119C29.0094 22.7821 29.2192 23.112 29.5173 23.3483C29.8154 23.5847 30.1844 23.7138 30.5649 23.7148C30.698 23.7145 30.8307 23.6985 30.9602 23.6674L34.2558 22.8835C34.3667 22.8606 34.4719 22.8156 34.5652 22.7513C34.6585 22.687 34.7379 22.6047 34.7987 22.5091C34.8596 22.4135 34.9006 22.3068 34.9195 22.195C34.9383 22.0833 34.9345 21.969 34.9083 21.8588C34.8821 21.7485 34.8341 21.6447 34.767 21.5534C34.7 21.4621 34.6153 21.3851 34.518 21.3272C34.4207 21.2692 34.3127 21.2313 34.2005 21.2158C34.0882 21.2003 33.9741 21.2075 33.8647 21.237L30.9814 21.9226C30.8724 21.9481 30.7578 21.9293 30.6626 21.8705C30.5674 21.8116 30.4994 21.7174 30.4734 21.6086L28.3182 12.549C28.2927 12.44 28.3115 12.3254 28.3704 12.2302C28.4292 12.135 28.5234 12.067 28.6322 12.041L30.6639 11.5585C30.7262 11.5437 30.7909 11.5431 30.8534 11.5569C30.9159 11.5707 30.9744 11.5985 31.0246 11.6382C31.0748 11.6779 31.1154 11.7284 31.1432 11.786C31.171 11.8436 31.1855 11.9068 31.1854 11.9708V18.6237C31.1854 19.0727 31.3638 19.5034 31.6813 19.8209C31.9988 20.1384 32.4294 20.3168 32.8785 20.3168H36.2646C36.4891 20.3168 36.7044 20.2276 36.8632 20.0688C37.0219 19.9101 37.1111 19.6947 37.1111 19.4702C37.1111 19.2457 37.0219 19.0304 36.8632 18.8716C36.7044 18.7129 36.4891 18.6237 36.2646 18.6237H36.2612Z" fill="#547AFF" />
                </g>
              </g>
              <path d="M14.0258 32.6354C14.0719 40.4087 7.79376 46.7491 0 46.7951C7.79376 46.7491 14.1472 53.0147 14.1929 60.7883C14.1472 53.0147 20.4269 46.6746 28.2178 46.6283C20.4269 46.6746 14.0719 40.4087 14.0258 32.6354Z" fill="#547AFF" />
              <path d="M115.626 18.559C115.663 24.7776 110.641 29.8499 104.406 29.8867C110.641 29.8499 115.723 34.8624 115.76 41.0813C115.723 34.8624 120.747 29.7904 126.98 29.7533C120.747 29.7904 115.663 24.7776 115.626 18.559Z" fill="#547AFF" />
              <path d="M28.1679 57.9731C28.1956 62.6371 24.4287 66.4413 19.7524 66.4689C24.4287 66.4413 28.2407 70.2007 28.2682 74.8649C28.2407 70.2007 32.0086 66.3966 36.6831 66.3689C32.0086 66.3966 28.1956 62.6371 28.1679 57.9731Z" fill="#547AFF" />
              <defs>
                <filter id="gpca_filter0_d" x="84.416" y="56.4357" width="46.5644" height="46.5644" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
                <filter id="gpca_filter1_d" x="39.2671" y="14.1089" width="68.0471" height="69.1386" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
                <filter id="gpca_filter2_d" x="15.7524" y="0" width="41.8614" height="41.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
        <div class="mx-n4">
          <div class="px-4 py-2 bg-light2">
            <!-- <p class="typo-paragraph14 typo-regular-150 text-light-low" v-html="addItemDesc"></p> -->
            <div class="checklist-item" v-for="(item, ind) in willAddItems" :key="Date.now() + '_p_' + ind">
              <i class="icon icon-check typo-icon-12 text-mono5"></i>
              <p class="typo-paragraph14 typo-regular text-light-low" v-html="$t('page.assignment.countTypeFrom', { count: item.checkedCount, type: $tc(`page.${type.replace('pages', 'Lower')}`, item.checkedCount), title: item.title })">
                <!-- {{ item.checkedCount }} products from {{ item.title }} -->
                {{}}
              </p>
            </div>
          </div>
        </div>
        <!-- <p class="typo-paragraph14 typo-regular text-mono3" v-if="willAddItems && willAddItems.length > 1"> -->
        <!-- **Total {{ totalWillAddItems }} products will be added to this template** -->
        <!-- {{ $t("page.assignment.totalItemsWillAdd", { count: totalWillAddItems, type: $tc(`page.${type.replace("pages", "Lower")}`, totalWillAddItems) }) }} -->
        <!-- </p> -->
      </template>
      <template #footer>
        <div class="btn-group flex-row-reverse">
          <template>
            <ProcessButton class="btn btn-primary ml-1" :status.sync="btnStatus" @click="confirmAddItems" type="submit">
              <template #loading>{{ $t("generals.loading") }}...</template>
              <template #success>{{ $t("generals.success") }}</template>
              <template #error>{{ $t("generals.error") }}</template>
              <!-- <template #default>{{ addItemBtnText }}</template> -->
              <template #default>{{ $t("page.assignment.addNow") }}</template>
            </ProcessButton>
          </template>

          <button class="btn btn btn-outline" @click="closeModalConfirmAddItems">{{ $t("generals.cancel") }}</button>
        </div>
      </template>
    </Modal>

    <!-- Modal UnAssign -->
    <Modal :hideExit="true" @cancel="closeModalV2('unAssign')" v-if="modals.unAssign.active" cClass="mw424">
      <template #header>
        <h1 class="typo-heading20 typo-medium text-light-high">{{ $t("modals.unAssign.title") }}</h1>
      </template>
      <template #default>
        <template>
          <p class="typo-paragraph14 typo-regular-150 text-light-low" v-html="unAssignDesc"></p>
        </template>
      </template>
      <template #footer>
        <div class="btn-group flex-row-reverse">
          <template>
            <ProcessButton class="btn btn-primary ml-1" :status.sync="btnStatus" @click="confirmAddItems(true)" type="submit">
              <template #loading>{{ $t("generals.loading") }}...</template>
              <template #success>{{ $t("generals.success") }}</template>
              <template #error>{{ $t("generals.error") }}</template>
              <template #default>{{ $t("modals.unAssign.btnPrimaryText") }}</template>
            </ProcessButton>
          </template>

          <button class="btn btn btn-outline" @click="closeModalV2('unAssign')">{{ $t("generals.cancel") }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import AssignList from "./Assignment/AssignList";
import AssignItem from "./Assignment/AssignListItem";
import { GpInputSearch, GpAccordion } from "@/core/shared/GpForms";
import { mapState, mapActions } from "vuex";
import processButton from "@/mixins/processButton.js";
import { PRODUCT_PAGE_EVENT, COLLECTION_PAGE_EVENT } from "@/config/constants/trackEventIds";
import { events } from '@/core/shared/Popover/bus';

export default {
  components: {
    AssignList,
    AssignItem,
    GpAccordion,
    GpInputSearch
  },
  mixins: [processButton()],
  props: {
    type: String,
    selectedTemplate: Object,
    pages: [Array, Object]
  },
  data() {
    return {
      queryRightSection: "",
      loadingRightSection: false,
      paginateAssignItems: {
        start: 0,
        limit: 10
      },
      modals: {
        unAssign: {
          active: false
        },
        addItems: {
          active: false
        },
        confirmAddItems: {
          active: false
        }
      },
      selectedUnAssign: null,
      querySearchAddItem: "",
      runnerSearch: null,
      loadingAddItems: false,
      forceShowItems: false,
      timeout: null,
      loadingInit: false,
      isLoading: false,
      isLoadingAssign: false
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo",
      permissions: "permissions"
    }),
    willAddItems() {
      let list = this.templateByGroup
        .map(item => {
          let newItem = JSON.parse(JSON.stringify(item));
          newItem.checkedCount = 0;
          if (newItem.assigns && newItem.assigns.length) {
            newItem.checkedCount = newItem.assigns.filter(x => x.checked).length;
          }
          return newItem;
        })
        .filter(item => item.checkedCount > 0);
      return list;
    },
    totalWillAddItems() {
      return this.willAddItems.reduce((accumulator, item) => accumulator + item.checkedCount, 0);
    },
    textDefault() {
      return {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      };
    },
    makeDefaultPages: () => ["template-collection", "template-index", "template-product"],
    assignedTooltipText() {
      if(this.type === 'productpages') {
        return this.$t('page.expandAssignedTooltip');
      }
      return this.$t('page.expandAssignedCollectionTooltip');
    },
    defaultAssignedText() {
      let type = this.$tc("page.productLower", 2);
      if (this.type == "collectionpages") {
        type = this.$tc("page.collectionLower", 2);
      }
      return this.$t("page.defaultAssigned", { type: type });
    },
    viewCountAssigned() {
      let list = (this.selectedTemplate && this.selectedTemplate.assigns) || [];
      let count = list.filter(item => item.template_suffix && item.template_suffix.includes("gem-")).length || 0;
      let type = this.$tc("page.productLower", count);
      if (this.type == "collectionpages") {
        type = this.$tc("page.collectionLower", count);
      }
      return this.$t("page.viewAssigned", { count, type });
    },
    rightSectionTitle() {
      if (this.type == "productpages") {
        return `${this.$t("generals.assigned")} ${this.$tc("page.product", 2)}`;
      }
      return `${this.$t("generals.assigned")} ${this.$tc("page.collection", 2)}`;
    },
    rightSectionBtnText() {
      if (this.type == "productpages") {
        return this.$t("page.addProduct");
      }
      return this.$t("page.addCollection");
    },
    rightSectionPlaceholder() {
      if (this.type == "productpages") {
        return this.$t("page.assignment.productPlaceholder");
      }
      return this.$t("page.assignment.collectionPlaceholder");
    },
    tooltipRightSection() {
      if (this.type == "productpages") {
        return this.$t("page.assignment.productTooltip");
      }
      return this.$t("page.assignment.collectionTooltip");
    },
    tooltipReloadStatus() {
      if (this.type == "productpages") {
        return this.$t("product.reload.status");
      }
      return this.$t("collection.reload.status");
    },
    isDefault() {
      if (this.layoutDefaultStatus) {
        return this.selectedTemplate.published ? true : false;
      }
      return false;
    },
    layoutDefaultStatus() {
      return this.makeDefaultPages.includes(this.selectedTemplate.type) ? true : false;
    },
    defaultTemplate() {
      let isLayoutDefault = template => (this.makeDefaultPages.includes(template.type) ? true : false);
      let isDefault = template => {
        if (isLayoutDefault(template)) {
          return template.published ? true : false;
        }
        return false;
      };
      return this.pages.find(template => isDefault(template));
    },
    rightSectionDesc() {
      return this.$t(`page.rightSectionDesc.${this.type}`);
    },
    sliceAssignItems() {
      let list = [];
      try {
        list = JSON.parse(JSON.stringify(this.assignList));
      } catch (error) {
        // Silent is golden
      }

      return list.filter(({ title }) => title.toLowerCase().includes(this.queryRightSection.trim().toLowerCase())).slice(this.paginateAssignItems.start, this.paginateAssignItems.start + this.paginateAssignItems.limit);
    },
    allAssignItems() {
      if (!this.assignList || !this.assignList.length) {
        return [];
      }
      return this.assignList
        .filter(({ title }) => title.toLowerCase().includes(this.queryRightSection.trim().toLowerCase()))
        .filter(item => item.template_suffix && item.template_suffix.includes("gem-"))
        .slice(0, this.paginateAssignItems.start + this.paginateAssignItems.limit);
    },
    unAssignDesc() {
      let type = this.$tc("page.productLower", 2);
      if (this.type == "collectionpages") {
        type = this.$tc("page.collectionLower", 2);
      }
      let template1 = this.selectedTemplate.title;
      let template2 = (this.defaultTemplate && this.defaultTemplate.title) || "";
      if (template2 && template2.length) {
        let transformDefault = this.textDefault[template2];
        if (transformDefault) {
          template2 = transformDefault;
        }
        template2 = `(${template2})`;
      }
      return this.$t("modals.unAssign.description", { type: type, template1, template2 });
    },
    templateByGroup() {
      let list = this.pages.filter(e => e.id != this.selectedTemplate.id).filter(e => e.assigns && e.assigns.length != 0);
      return list;
    },
    querriedTemplateByGroup() {
      let query = this.querySearchAddItem.toLowerCase() || "";
      let list = this.templateByGroup
        .filter(e => {
          let itemFilter = e.assigns.filter(item => item.title.toLowerCase().includes(query));
          return e.id != this.selectedTemplate.id && itemFilter && itemFilter.length > 0;
        })
        .sort((a, b) => {
          if (this.textDefault[a.title] != undefined) return -1;
          if (this.textDefault[b.title] != undefined) return 1;
          // return b.assigns.length - a.assigns.length;
          return 0;
        })
        .filter(e => e.assigns.length != 0);
      // Filter by search
      list = list.map(e => {
        let elem = JSON.parse(JSON.stringify(e));
        elem.assigns = e.assigns.filter(item => item.title.toLowerCase().includes(query));
        return elem;
      });
      return list;
    },
    modalAddItemsHeader() {
      if (this.type == "productpages") {
        return `${this.$t("generals.add")} ${this.$tc("page.product", 2)}`;
      }
      return `${this.$t("generals.add")} ${this.$tc("page.collection", 2)}`;
    },
    modalAddItemsBtnText() {
      if (this.type == "productpages") {
        return `${this.$t("generals.add")} ${this.$tc("page.product")}`;
      }
      return `${this.$t("generals.add")} ${this.$tc("page.collection")}`;
    },
    addItemBtnText() {
      if (this.type == "productpages") {
        return this.$t("page.addProduct");
      }
      return this.$t("page.addCollection");
    },
    assignList() {
      if (this.selectedTemplate && this.selectedTemplate.assigns && this.selectedTemplate.assigns.length) {
        let list = [...this.selectedTemplate.assigns];
        list.sort((a, b) => {
          if (a.isNew && !b.isNew) return -1;
          if (b.isNew && !a.isNew) return 1;
          if (a.isNew && b.isNew) {
            return new Date(b.updated_at) - new Date(a.updated_at);
          }
          return 0;
        });
        return list;
      }
      return [];
    }
    // addItemDesc() {
    //   let selectedIDs = [];
    //   this.querriedTemplateByGroup.forEach(e => {
    //     e.assigns.forEach(el => {
    //       if (el.checked) {
    //         selectedIDs.push(el.id);
    //       }
    //     });
    //   });

    //   let number = selectedIDs.length;

    //   if (this.type == "productpages") {
    //     return this.$t("page.addProductDesc", { number: number, title: this.selectedTemplate.title });
    //   }
    //   return this.$t("page.addCollectionDesc", { number: number, title: this.selectedTemplate.title });
    // }
  },
  watch: {
    templateByGroup(newV) {
      if (newV && newV.length == 1) {
        this.forceShowItems = true;
      } else {
        this.forceShowItems = false;
      }
    },
    // querriedTemplateByGroup(newV) {

    // },
    selectedTemplate(n, o) {
      if ((n && n.id) == (o && o.id)) {
        return;
      }
      this.loadingInit = true;
      this.timeout = setTimeout(() => {
        this.loadingInit = false;
      }, 300);
    }
  },
  created() {
    // this.initScrollAssignItems();
  },
  methods: {
    ...mapActions("page", {
      assignTemplate: "assignTemplate",
      searchItems: "searchItems",
      fetchAllItems: "fetchAllItems",
      fetchAllAssignItems: "fetchAllAssignItems"
    }),
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    resetSearch() {
      this.queryRightSection = "";
    },
    async fetchAllItemsByType() {
      this.isLoading = true;
      const type = this.type;
      this.querySearchAddItem = "";
      this.$store.state.page.assignments[type].fetched = false;
      events.$emit("hide:hover");
      await this.fetchAllItems({
        shop: this.shopInfo.shopifyDomain,
        type: type
      });
      this.isLoading = false;
    },
    async fetchAllAssignItemsByType() {
      this.isLoadingAssign = true;
      const type = this.type;
      this.$store.state.page.assignments[type].fetchedAssign = false;
      events.$emit("hide:hover");
      await this.fetchAllAssignItems({
        shop: this.shopInfo.shopifyDomain,
        type: type
      });
      this.isLoadingAssign = false;
    },
    // eslint-disable-next-line no-unused-vars
    onChangeSearchRightSection(data) {
      this.runnerSearch && clearTimeout(this.runnerSearch);
      this.loadingRightSection = true;

      if (data.value.trim()) {
        this.runnerSearch = setTimeout(async () => {
          await this.searchItems({
            type: this.type,
            shop: this.shopInfo.shopifyDomain,
            query: data.value.trim()
          });
          this.reloadAssignItemsList();
          this.loadingRightSection = false;
        }, 300);
      } else {
        this.reloadAssignItemsList();
        this.loadingRightSection = false;
      }
    },
    doLoadMoreAssignItems() {
      this.paginateAssignItems.start += this.paginateAssignItems.limit;
    },
    onClickUnAssign(id) {
      this.selectedUnAssign = id;
      this.openModalV2("unAssign");
    },
    titlePage(page) {
      if (this.isOriginalShopifyPage(page)) {
        return this.textDefault[page.title];
      }
      return page.title;
    },
    isOriginalShopifyPage(page) {
      return this.textDefault[page.title] ? true : false;
    },
    calcScroll() {
      var container = document.querySelector(".assign-list");
      if (container) {
        if (container.scrollTop >= container.scrollHeight - container.offsetHeight) {
          this.doLoadMoreAssignItems();
        }
      }
    },
    initScrollAssignItems() {
      const container = document.querySelector(".assign-list");
      if (container) {
        container.addEventListener("scroll", this.calcScroll);
      }
    },
    reloadAssignItemsList() {
      this.paginateAssignItems = {
        start: 0,
        limit: 10
      };
    },
    emitClose() {
      this.$emit("closeRightSection");
    },
    closeModalV2(type) {
      this.resetStatus();
      this.modals[type].active = false;
    },
    closeModalConfirmAddItems() {
      this.closeModalV2("confirmAddItems");
      this.$emit("close:add");
    },
    closeModalAddItems() {
      this.querySearchAddItem = "";
      this.closeModalV2("addItems");
      this.$emit("close:add");
    },
    openModalV2(type) {
      if (type == "addItems") {
        this.trackOpenModalAssignItemsEvent();
      }

      this.modals[type].active = true;
    },
    trackOpenModalAssignItemsEvent() {
      let eventId = null;

      if (this.type == "collectionpages") {
        eventId = COLLECTION_PAGE_EVENT.OPEN_ADD_COLLECTION_POPUP_CLICKED;
      } else {
        eventId = PRODUCT_PAGE_EVENT.OPEN_ADD_PRODUCT_POPUP_CLICKED;
      }

      this.trackEvent({
        event_id: eventId,
        properties: {
          template_page_id: this.selectedTemplate.id,
          text: this.rightSectionBtnText
        }
      });
    },
    submitAddItems() {
      this.trackSubmitAddItemsEvent();
      this.closeModalV2("addItems");
      this.querySearchAddItem = "";

      let selectedIDs = [];
      this.templateByGroup.forEach(e => {
        e.assigns.forEach(el => {
          if (el.checked) {
            selectedIDs.push(el.id);
          }
        });
      });

      if (!selectedIDs || !selectedIDs.length) {
        return;
      }

      this.openModalV2("confirmAddItems");
    },
    trackSubmitAddItemsEvent() {
      let eventId = null;

      if (this.type == "collectionpages") {
        eventId = COLLECTION_PAGE_EVENT.ADD_COLLECTION_CLICKED;
      } else {
        eventId = PRODUCT_PAGE_EVENT.ADD_PRODUCT_CLICKED;
      }

      this.trackEvent({
        event_id: eventId,
        properties: {
          text: this.rightSectionBtnText,
          template_page_id: this.selectedTemplate.id,
          template_status: this.templateStatus(this.selectedTemplate)
        }
      });
    },
    templateStatus(template) {
      if (template.published) return "default";
      if (template.is_published) return "publish";
      return "unpublish";
    },
    confirmAddItems(unAssign = false) {
      let selectedIDs = [];
      let templateId;
      templateId = this.selectedTemplate.id;

      this.willAddItems.forEach(e => {
        e.assigns.forEach(el => {
          if (el.checked) {
            selectedIDs.push(el.id);
          }
        });
      });
      selectedIDs = selectedIDs.join(",");
      // if (this.selectedTemplate && this.selectedTemplate.published) {
      //   templateId = "inherit";
      // }
      if (unAssign) {
        templateId = 0;
        selectedIDs = this.selectedUnAssign.toString();
      }
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.activeLoading();
      let params = {
        shop: this.shopInfo.shopifyDomain,
        type: this.type,
        templateId: templateId,
        assignId: selectedIDs,
        onSuccess: () => {
          this.activeSuccess();
          this.closeModalConfirmAddItems();
          if (unAssign) {
            this.closeModalV2("unAssign");
          }
          this.gSnackbarCommit({
            message: this.$t("status.success"),
            type: "success"
          });

          // if (this.type == "productpages" || this.type == "collectionpages") {
          //   this.reloadAssigns();
          // }
        },
        // eslint-disable-next-line no-unused-vars
        onError: error => {
          this.activeError();
          this.closeModalConfirmAddItems();
          if (unAssign) {
            this.closeModalV2("unAssign");
          }
          this.gSnackbarCommit({
            message: this.$t("status.error"),
            type: "error"
          });
        }
      };
      this.assignTemplate(params);
    },
    onChangeSearchAddItem(data) {
      this.runnerSearch && clearTimeout(this.runnerSearch);
      if (data.value.trim()) {
        this.loadingAddItems = true;

        this.runnerSearch = setTimeout(async () => {
          await this.searchItems({
            type: this.type,
            shop: this.shopInfo.shopifyDomain,
            query: data.value
          });
          this.loadingAddItems = false;
        }, 300);
      } else {
        this.loadingAddItems = false;
      }
    },
    isMakeDefault(page) {
      return page.published;
    },
    itemCount(page) {
      let number = 0;
      if (page.assigns != null) {
        number = page.assigns.length;
      }

      if (this.querySearchAddItem.trim() == "") {
        if (this.isMakeDefault(page) && this.totalItems) {
          number = this.totalItems;
        }
      }

      if (this.type == "productpages") {
        if (number > 1) {
          return number + " " + this.$tc("page.productLower", 2);
        }
        return number + " " + this.$tc("page.productLower", 1);
      }
      if (number > 1) {
        return number + " " + this.$tc("page.collection", 2);
      }
      return number + " " + this.$tc("page.collection", 1);
    },
    checkedUpdateItem(val) {
      this.templateByGroup.forEach(e => {
        e.assigns.forEach(el => {
          if (el.id == val.id) {
            el.checked = val.value;
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.assign-right-section--actions {
  width: 16px;
  height: 16px;
}
.gp-modal-add-items-head--actions,
.assign-right-section-actions {
  .snack-loading {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  a {
    font-size: 11px;
  }
  .close-assign {
    font-size: 10px;
  }
  a, .close-assign {
    border-radius: 3px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $dark6;
    &:hover {
      text-decoration: none;
      color: $textLightModeHigh;
    }
    margin-right: 8px;
    &:last-of-type {
      margin-right: 0;
    }
    &.disabled,
    &:disabled {
      pointer-events: none;
    }
    @media (max-width: 1660px) {
      width: 20px;
    }
    @media (max-width: 1156px) {
      width: 15px;
    }
    @media (max-width: 1414px) {
      width: 12px;
    }
  }
}

.gp-modal-add-items {
  .add-item-title {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden !important;
    text-overflow: ellipsis;
    // flex: 1;
    max-width: calc(100% - 100px);
  }
}

.btn {
  min-height: 40px;
}
.right-section {
  min-width: 312px;
  max-width: 312px;

  @media (max-width: 1279px) {
    min-width: 253px;
    max-width: 253px;
  }

  .assign-right-section {
    border-radius: $radius;
    background: $light1;
    border: 1px solid $dark3;
    box-sizing: border-box;

    // 24 is pagination height, 30 is margin-top of pagination
    height: 560px;
    ::v-deep .assign-item {
      // cursor: default !important;
      padding-left: 8px;
      padding-right: 4px;
    }
  }
}

.add-items-body {
  // overflow-y: overlay;
  // height: calc(100vh - (66px + 40px + 24px + 24px + 32px + 72px + 16px));
  height: calc(100vh - (274px));
  ::v-deep .accordion-item {
    background: none;
    border: none;
    @include trans-all;
    margin-top: 0;

    // &:not(:last-of-type) {
    margin-bottom: 16px;
    // }

    .heading-bounder {
      padding: 0;
      margin: 0;
      padding: 10px 16px 11px 16px;
      display: block;
      border-radius: $radius;
      background: $light2;
      @include trans-all;

      i {
        @include trans-all;
      }
      &:hover {
        background: $textDarkModeHigh !important;
        .heading {
          .title {
            color: $textLightModeHigh !important;
          }
        }
      }
      .heading {
        margin-bottom: 0 !important;

        .title {
          color: $textLightModeHigh;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
        }
      }
    }

    .content {
      // overflow-y: overlay;
      .assign-item {
        border: none;
        background: $light1;
        padding-left: 8px;
        width: 100%;
      }
    }

    &.active {
      .heading-bounder {
        i {
          transform: rotate(180deg);
        }
      }
    }
  }
}

.border-dashed-gold {
  border: 1px dashed #fdb913;
}

.accordion-item.expandable {
  border: none;

  ::v-deep .heading-bounder {
    margin: 0;
    background: $light2;
    border-radius: $radius;
    padding: 8px 16px;
    margin-bottom: 4px;
    @include trans-all;
    &:hover {
      background: $light3;
    }
  }

  ::v-deep .actions {
    display: flex;
    .arrow {
      display: inline-flex;
      transition: transform 0.3s ease;
    }
  }

  &.active {
    // ::v-deep .heading-bounder {
    //   background: $light2;
    // }
    ::v-deep .actions {
      .arrow {
        transform: rotate(90deg);
      }
    }
  }
}

.ps {
  ::v-deep .ps__rail-y {
    z-index: 2;
  }
}

.right-search {
  ::v-deep input {
    background: $light2;
  }
}

.typo-custom-22b150 {
  font-size: 22px;
  line-height: 150%;
  font-weight: bold;
}

.checklist-item {
  // padding-left: 36px;
  display: flex;
  i.icon {
    align-self: flex-start;
    margin-top: 2px;
    margin-right: 8px;
  }
  p {
    flex: 1;
  }

  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
}
.snack-loading {
  animation: cog 1s infinite;
  display: flex;
  align-items: center;
  justify-content: center;
}
@keyframes cog {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
